(function () {
    'use strict';

    var $ = window.jQuery;

    function ArkansasSchedule(options) {
        if (!options) {
            throw new Error('No options passed to ArkansasSchedule constructor');
        }
        if (!options.baseUrl) {
            throw new Error('No baseUrl option passed to ArkansasSchedule constructor');
        }
        if (!options.sport) {
            throw new Error('No sport option passed to ArkansasSchedule constructor');
        }
        if (!options.season) {
            throw new Error('No season option passed to ArkansasSchedule constructor');
        }

        this.options = $.extend({}, ArkansasSchedule.defaults, options);

        this.setupSelectSeason();
        this.initScheduleRecords();
    }

    ArkansasSchedule.prototype.setupSelectSeason = function () {
        var $self = this;
        $(this.options.seasonSelect).on('change', function () {
            window.location.href = $self.options.baseUrl + '/?season=' + $(this).val();
        });

    };

    ArkansasSchedule.prototype.initScheduleRecords = function () {
        if(this.options.enable_stats_block === 0) {
            return false;
        }

        if (!this.options.sport || !this.options.season) {
            return false;
        }

        var $self = this,
            $schedule_result_container = $(this.options.scheduleScore),
            $template = wp.template(this.options.template_selector);

        if (!$schedule_result_container.length || !$template) {
            return;
        }

        $.ajax({
            url: '/wp-json/arkansas/v2/load_schedule_records',
            dataType: 'json',
            cache: true,
            data: {
                sport_category_id: $self.options.sport,
                season_id: $self.options.season
            },
            success: function (json) {
                firePageView();
                $.each(json, function (k, v) {
                    $($self.options.scheduleScore).append($template(v));
                });
            }
        });
    };

    ArkansasSchedule.defaults = {
        seasonSelect: '#seasonSelect',
        scheduleScore: '#schedule_score_container',
        template_selector: 'schedule-results'
    };

    window.ArkansasSchedule = ArkansasSchedule;
}())
;